import React, { useContext } from 'react';
import { SpringRef } from '@react-spring/web';

import type { SprungRect, TRect } from '../../../types/misc';
import {
  TOverlayLocations,
  TSprungOverlayLocations
} from '../../../utils/wysiwyg_editor/contentItemHandleLocations';
import { WysiwygEditorStateContext } from '@src/contexts/wysiwyg/editor';
import { TImageContentItem } from '@src/types/wysiwyg_editor';
import PreviewImage from './PreviewImage';
import BuilderImage from './BuilderImage';

export interface Props {
  data: TImageContentItem;
  frameDomSpringValues: TSprungOverlayLocations;
  frameDomSpringApi: SpringRef<TOverlayLocations>;
  frameViewboxSpringValues: SprungRect;
  frameViewboxSpringApi: SpringRef<TRect>;
}

function Image(props: Props): React.ReactElement {
  const { productionRender } = useContext(WysiwygEditorStateContext);

  if (productionRender) {
    return <PreviewImage {...props} />;
  } else {
    return <BuilderImage {...props} />;
  }
}

export default Image;
